import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Grid, IconButton, Tooltip } from "@mui/material";
import ExplorerGrid, { useExplorerGrid } from "common/ExplorerGrid";
import { Can } from "context/permissionContenxt";
import PageNotFound from "pages/PageNotFound";
import useToolbarProps from "qubCommon/ExplorerToolbar/useToolbarProps";
import { TextInput } from "qubCommon/Inputs";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Program6BeneficiariesExplorer = () => {
  const navigate = useNavigate();
  const { seasonId, user } = useSelector((state) => state.auth);
  const [contextMenuIds, setContextMenuIds] = useState({});
  const { status, ...toolbarProps } = useToolbarProps({
    webPageKey: "Program6Beneficiaries-Expl",
    hideAddNew: true,
  });

  const openApplication = (item) => {
    if (!item?.ApplicationId) return;
    const path = `/student-application/${item.ApplicationId}`;
    window.open(`/lae-miteres${path}`, "_blank", "noopener,noreferrer");
  };

  const handlePopup = (item) => {
    setContextMenuIds({
      applicationId: item?.ApplicationId,
      applicationRenderOptions: "student-application",
    });
  };

  const { explParams, ...explorerProps } = useExplorerGrid({
    explorerDataKey: "Program6Beneficiaries-Expl",
    xlsxName: "Program6Beneficiaries",
    status,
    onPopup: handlePopup,
    onSelect: openApplication,
    rowHeaderTitle: "#",
  });

  const buildFilterSummary = (filterParams) => {
    const summary = [];
    const criteria = explorerProps.toolbarRef.current?.criteriaRef?.current;

    if (filterParams?.searchFieldValue?.trim()) {
      summary.push({
        title: "Αναζήτηση",
        value: filterParams.searchFieldValue.trim(),
      });
    }

    criteria?.critValuesList?.forEach((group) => {
      const selectedTitles = group?.children
        ?.filter((child) => child.isSelected)
        .map((child) => child.title)
        .filter(Boolean);
      if (selectedTitles?.length) {
        summary.push({
          title: group.title,
          value: selectedTitles.join(", "),
        });
      }
    });

    criteria?.critFldsSearch?.forEach((field) => {
      if (!field?.value1 && !field?.value2) return;
      summary.push({
        title: field.title,
        value:
          field.value1 && field.value2
            ? `${field.value1} έως ${field.value2}`
            : field.value1 || field.value2,
      });
    });

    return summary;
  };

  const openFilteredReport = (filterParams) => {
    const filterKey = crypto.randomUUID();
    const requestedBy =
      user?.email ||
      user?.userName ||
      [user?.lastName, user?.firstName].filter(Boolean).join(" ") ||
      "—";
    sessionStorage.setItem(
      `program6-beneficiaries-report:${filterKey}`,
      JSON.stringify({
        parameters: filterParams,
        filterSummary: buildFilterSummary(filterParams),
        requestedBy,
      })
    );
    window.open(
      `${import.meta.env.BASE_URL}govnr/reports/successful-without-lottery?seasonId=${seasonId}&filterKey=${filterKey}`,
      "_blank"
    );
  };

  const pdfFiles = [
    ...(toolbarProps.pdfFiles ?? []),
    {
      rptId: "program6-beneficiaries-filtered",
      rptTitle: "Αναφορά επιτυχόντων/ουσών (τρέχοντα φίλτρα)",
      onPick: openFilteredReport,
    },
  ];

  const toolbarButtons = (
    <Tooltip title="Επιστροφή στις αιτήσεις">
      <IconButton onClick={() => navigate("/govnr/applications")}>
        <ArrowBackIcon />
      </IconButton>
    </Tooltip>
  );

  return (
    <>
      <Can I="View" a="GovnrApplications">
        <div
          style={{
            margin: 20,
            padding: 20,
            borderRadius: 8,
            backgroundColor: "#f3f3f3",
          }}
        >
          <ExplorerGrid
            explParams={explParams}
            title="Επιτυχόντες/ούσες Πανελλαδικών ανά τέκνο"
            breadcrumbs={[
              {
                name: "Επιτυχόντες/ούσες Πανελλαδικών",
                path: "govnr/student-beneficiaries",
              },
            ]}
            autoRowHeights
            contextMenuIds={contextMenuIds}
            buttons={toolbarButtons}
            {...explorerProps}
            {...toolbarProps}
            pdfFiles={pdfFiles}
          >
            <Grid item xs={12} md={6} lg={4}>
              <TextInput
                id="Search"
                name="searchFieldValue"
                label="Αναζήτηση"
                placeholder="Αίτηση, αιτών/ούσα, τέκνο, ΑΜΚΑ, ΑΦΜ ή IBAN"
              />
            </Grid>
          </ExplorerGrid>
        </div>
      </Can>
      <Can not I="View" a="GovnrApplications">
        <PageNotFound />
      </Can>
    </>
  );
};

export default Program6BeneficiariesExplorer;
